import { baseSubscription } from '@/utils/subscriptionHandler';
import Subscriptions from '@/services/graphql/subscriptions';
const onSortingDocumentChangeSubscription = (variables, next) => baseSubscription({
  variables,
  next,
  subscriptionFunction: Subscriptions.onSortingDocumentChange,
},);
export { onSortingDocumentChangeSubscription };
